import { SvgIcon, type SvgIconProps } from '@mui/material'

export function GeofenceInOut(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M18.026 4.938a.823.823 0 0 1 0 1.148.787.787 0 0 1-1.127 0C13.682 2.81 8.476 2.802 5.27 6.068c-3.205 3.265-3.198 8.569.019 11.846 3.216 3.276 8.422 3.284 11.628.018a.786.786 0 0 1 1.127 0 .822.822 0 0 1 0 1.148 9.69 9.69 0 0 1-13.882-.018C.323 15.152.315 8.82 4.143 4.92a9.69 9.69 0 0 1 13.883.018Zm2.477 8.851a.72.72 0 0 1-1.018-1.016l2.062-2.058h-6.828a.719.719 0 1 1 0-1.438h6.82l-2.054-2.05a.716.716 0 0 1 0-1.016.72.72 0 0 1 1.018 0l3.285 3.281a.715.715 0 0 1 0 1.016l-3.285 3.281Zm-9.007 4L8.21 14.51a.718.718 0 0 1 0-1.017l3.286-3.281a.72.72 0 0 1 1.017 1.016l-2.053 2.05h6.82a.718.718 0 1 1 0 1.438h-6.83l2.062 2.058a.72.72 0 0 1-1.018 1.016Z" />
    </SvgIcon>
  )
}
